var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"md":_vm.md,"cols":"12"}},[_c('editor',{attrs:{"api-key":_vm.apiKey,"init":_vm.init,"value":_vm.value,"name":"editor"},on:{"input":_vm.updateValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }